import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class TeamModel extends Model 
{
	@attr name;
	@attr bib;
	@attr country;
	@attr club;
	@attr('number',{defaultValue: 0}) id1;
	@attr('number',{defaultValue: 0}) id2;
	@attr('number',{defaultValue: 0}) id3;
	@attr({defaultValue:'OK'}) status;
	
	@belongsTo('event', {inverse:'teams', async: true}) EventId;
	@hasMany('entry', {inverse:'TeamId', async: true}) entries;
}